import { WHATSAPP_NUMBER } from "../data/products";

export const buildProductMessage = (product, qty = 1) => {
  const lines = [
    "Bună ziua! Doresc să comand următorul produs:",
    "",
    `• ${product.title}`,
    `  Cantitate: ${qty}`,
    `  Preț: ${product.price} lei`,
    "",
    `Total: ${(product.price * qty).toFixed(2)} lei`,
    "",
    "Vă rog să mă contactați pentru detalii de livrare. Mulțumesc!",
  ];
  return lines.join("\n");
};

export const buildCartMessage = (items, total, customer = null) => {
  const lines = [
    "Bună ziua! Doresc să plasez următoarea comandă cu plată la livrare:",
    "",
    "═══ PRODUSE ═══",
    ...items.map(
      (it, idx) =>
        `${idx + 1}. ${it.title}\n   Cantitate: ${it.qty} × ${it.price} lei = ${(it.qty * it.price).toFixed(2)} lei`,
    ),
    "",
    `TOTAL: ${total} lei`,
    "",
  ];

  if (customer) {
    lines.push("═══ DATE LIVRARE ═══");
    lines.push(`Nume: ${customer.fullName}`);
    lines.push(`Telefon: ${customer.phone}`);
    if (customer.email) lines.push(`Email: ${customer.email}`);
    lines.push(`Adresă: ${customer.address}`);
    lines.push(`Localitate: ${customer.city}`);
    if (customer.county) lines.push(`Județ: ${customer.county}`);
    if (customer.postalCode) lines.push(`Cod poștal: ${customer.postalCode}`);
    if (customer.notes) {
      lines.push("");
      lines.push(`Mențiuni: ${customer.notes}`);
    }
    lines.push("");
    lines.push("Modalitate plată: NUMERAR LA LIVRARE (ramburs)");
    lines.push("");
    lines.push("Mulțumesc! Aștept confirmarea.");
  } else {
    lines.push("Vă rog să mă contactați pentru a confirma livrarea. Mulțumesc!");
  }

  return lines.join("\n");
};

export const openWhatsApp = (message) => {
  const url = message
    ? `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
    : `https://wa.me/${WHATSAPP_NUMBER}`;
  window.open(url, "_blank", "noopener,noreferrer");
};
